import { PropsWithChildren } from "react";
import { AddOrderArticleContext } from "../global/utils/order/addOrderArticleContext.tsx";
import useAddOrderArticleToShoppingCart from "../global/utils/order/useAddOrderArticleToShoppingCart.tsx";
import { useIntl } from "react-intl";
import useAnalytics from "../global/utils/analytics/useAnalytics.ts";

export default function InnerApp(props: PropsWithChildren) {
  const addOrderArticle = useAddOrderArticleToShoppingCart();
  window.globalIntl = useIntl();
  useAnalytics();
  return <AddOrderArticleContext.Provider value={addOrderArticle}>{props.children}</AddOrderArticleContext.Provider>;
}
